import { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { useSelector } from "react-redux";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import _ from "lodash";

import classes from "../maintainers.module.scss";
import { customStyles } from "./products.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const units = [
	{ value: "g", label: "g" },
	{ value: "cc", label: "cc" },
];

const ProductsFilter = ({ filter, applyFilter, isMaintainerView }) => {
	const { countries, dealers, aptitudes, chemicals } = useSelector((state) => state.maintainers_products);

	const filterCategory = filter.category_id;
	const [filterCountry, setFilterCountry] = useState(filter.country_id);
	const [filterDealer, setFilterDealer] = useState(filter.dealer_id);
	const [filterAptitude, setFilterAptitude] = useState(filter.aptitud_id);
	const [filterChemical, setFilterChemical] = useState(filter.chemical_id);
	const [filterUnit, setFilterUnit] = useState(filter.unit_measurement);
	const [filterGeneric, setFilterGeneric] = useState(filter.is_generic);

	const handleApplyFilter = () => {
		applyFilter({
			filterCountry,
			filterDealer,
			filterAptitude,
			filterChemical,
			filterUnit,
			filterGeneric,
			filterCategory,
		});
	};

	const handleCleanFilter = () => {
		if (!isMaintainerView) {
			applyFilter({
				filterCountry,
				filterGeneric,
				filterDealer: "",
				filterAptitud: "",
				filterChemical: "",
				filterUnit: "",
				filterCategory: "",
			});

			return;
		}

		applyFilter({
			filterCountry: "",
			filterDealer: "",
			filterAptitud: "",
			filterChemical: "",
			filterUnit: "",
			filterGeneric: "",
			filterCategory: "",
		});
	};

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr style={{ marginTop: "0.5em", marginBottom: "0.5em" }} />

			<div className={classes.divContent}>
				{isMaintainerView && (
					<>
						<Row className={classes.divForm}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>País</span>
							</Col>

							<Col md={12}>
								<Select
									value={countries.filter((c) => String(c.value) === String(filterCountry))}
									placeholder={<div>Seleccione</div>}
									options={countries ? countries : []}
									onChange={(value) => {
										setFilterCountry(value.value);
									}}
									components={{
										NoOptionsMessage,
									}}
									menuPortalTarget={document.body}
									styles={customStyles}
								/>
							</Col>
						</Row>
					</>
				)}

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Unidad de Medida</span>
					</Col>

					<Col md={12}>
						<Select
							value={units.filter((c) => c.value === filterUnit)}
							placeholder={<div>Seleccione</div>}
							options={units ? units : []}
							onChange={(value) => {
								setFilterUnit(value.value);
							}}
							components={{
								NoOptionsMessage,
							}}
							menuPortalTarget={document.body}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Aptitud</span>
					</Col>

					<Col md={12}>
						<Select
							value={
								aptitudes &&
								aptitudes.filter(
									(a) => filterAptitude && filterAptitude.length > 0 && _.map(filterAptitude.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={aptitudes ? aptitudes : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setFilterAptitude(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				{isMaintainerView && (
					<>
						<Row className={classes.divForm}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>Distribuidor</span>
							</Col>

							<Col md={12}>
								<Select
									value={
										dealers &&
										dealers.filter(
											(a) => filterDealer && filterDealer.length > 0 && _.map(filterDealer.split(","), Number).includes(Number(a.value)),
										)
									}
									isMulti
									placeholder={<div>Seleccione</div>}
									options={dealers ? dealers : []}
									onChange={(value) => {
										let baseValue = [];
										value.forEach((element) => {
											baseValue.push(element.value);
										});

										setFilterDealer(baseValue.length !== 0 ? baseValue.toString() : "");
									}}
									components={{ NoOptionsMessage }}
									styles={customStyles}
								/>
							</Col>
						</Row>

						<Row className={classes.divForm}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>Química</span>
							</Col>

							<Col md={12}>
								<Select
									value={
										chemicals &&
										chemicals.filter(
											(a) =>
												filterChemical &&
												filterChemical.length > 0 &&
												_.map(filterChemical.split(","), Number).includes(Number(a.value)),
										)
									}
									isMulti
									placeholder={<div>Seleccione</div>}
									options={chemicals ? chemicals : []}
									onChange={(value) => {
										let baseValue = [];
										value.forEach((element) => {
											baseValue.push(element.value);
										});

										setFilterChemical(baseValue.length !== 0 ? baseValue.toString() : "");
									}}
									components={{ NoOptionsMessage }}
									styles={customStyles}
								/>
							</Col>
						</Row>

						<Row className={classes.divForm}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>Productos</span>
							</Col>
							<Col md={12} style={{ textAlign: "center", marginBottom: "10px" }}>
								<CustomInputSwitch
									value={filterGeneric}
									optionLeft="Normal"
									optionRight="Genérico"
									onChange={(checked) => {
										setFilterGeneric(checked);
									}}
								/>
							</Col>
						</Row>
					</>
				)}
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default ProductsFilter;
